import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import './NotFound.css';

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | MovieHub888</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="not-found-container">
        <div className="not-found-content">
          <div className="movie-icon">
            🎬
          </div>
          <h1 className="error-code">
            404
          </h1>
          <h2 className="error-title">Oops! Page Not Found</h2>
          <p className="error-message">
            Looks like this scene got cut from the final edit!
          </p>
          <Link to="/" className="home-button"> {/* Use Link with the 'to' prop */}
            Back to MovieHub
          </Link>
          <div className="error-footer">
            Error Code: 🎬-404-ACTION!
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
